// extracted by mini-css-extract-plugin
module.exports = {"questionDetails":"QuestionDetails_questionDetails__7gjEX","questionIndex":"QuestionDetails_questionIndex__LLNF-"};